import { render } from "./PokemonsList.vue?vue&type=template&id=05b67358&scoped=true"
import script from "./PokemonsList.vue?vue&type=script&lang=js"
export * from "./PokemonsList.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./PokemonsList.vue?vue&type=style&index=1&id=05b67358&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b67358"]])

export default __exports__